import { TFunction } from 'i18next';
import { EidProvider, Country, Language, ServiceType } from '@idk-web/api';

export function translateLanguage(t: TFunction, language: Language): string {
  switch (language) {
    case Language.ENGLISH:
      return t('common.language.english');
    case Language.SWEDISH:
      return t('common.language.swedish');
    case Language.NORWEGIAN:
      return t('common.language.norwegian');
    case Language.DANISH:
      return t('common.language.danish');
    case Language.FINNISH:
      return t('common.language.finnish');
  }
}

export function translateCountry(t: TFunction, country: Country): string {
  switch (country) {
    case Country.SWEDEN:
      return t('common.country.sweden');
    case Country.NORWAY:
      return t('common.country.norway');
    case Country.DENMARK:
      return t('common.country.denmark');
    case Country.FINLAND:
      return t('common.country.finland');
  }
}

export function translateService(t: TFunction, service: ServiceType): string {
  switch (service) {
    case ServiceType.TELEID:
      return t('common.service.teleid');
    case ServiceType.TELESIGN:
      return t('common.service.telesign');
    case ServiceType.SAFEMAIL:
      return t('common.service.safemail');
  }
}

export function translateProvider(t: TFunction, provider: EidProvider): string {
  switch (provider) {
    case EidProvider.BANKID:
      return t('common.provider.bankid');
    case EidProvider.FREJA:
      return t('common.provider.freja');
    case EidProvider.BANKID_NO:
      return t('common.provider.bankid_no');
    case EidProvider.MITID:
      return t('common.provider.mitid');
    case EidProvider.FTN:
      return t('common.provider.ftn');
    case EidProvider.VIPPS:
      return t('common.provider.vipps');
    case EidProvider.MOBILE_PAY:
      return t('common.provider.mobile_pay');
  }
}
